import React from "react";

function FileUpload(props) {
  const { field, form } = props;

  const handleChange = (e) => {
    if (e.currentTarget.files[0]) {
      const file = e.currentTarget.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      form.setFieldValue(field.name, file);
    }
  };

  return (
    <>
      <input
        type={"file"}
        onChange={(o) => handleChange(o)}
        className={"form-control"}
      />
    </>
  );
}

export default FileUpload;
